export const splitProductDescription = (description: string) => {
  const descriptionParts = description.split('---')

  const descriptionBlock =
    descriptionParts.length < 2 ? descriptionParts[0] : descriptionParts[1]
  const highlightBlock =
    descriptionParts.length > 1 ? descriptionParts[0] : undefined

  return {
    descriptionBlock,
    highlightBlock,
  }
}
